'use client';

import { ChevronRight } from 'lucide-react';
import { useState } from 'react';

import {
	type StartDialogResult,
	startDialogAction,
} from '@/features/ai-dialog';
import { useToast } from '@/features/toast';
import { Button } from '@/shared';
import type { GetAIProblemResponseV1 } from '@/shared/api';

import { INTERVIEW_GATE_MESSAGE } from '../lib/consts';

type InterviewGateProps = {
	problemId: string;
	problem: GetAIProblemResponseV1;
	languageId?: number;
	message?: string;
	onStarted: (result: StartDialogResult) => void;
};

export function InterviewGate({
	problemId,
	problem,
	languageId,
	message = INTERVIEW_GATE_MESSAGE,
	onStarted,
}: InterviewGateProps) {
	const { addToast } = useToast();
	const [loading, setLoading] = useState(false);

	const handleStart = async () => {
		setLoading(true);
		try {
			const result = await startDialogAction(problemId, languageId);
			if (result) {
				onStarted(result);
			} else {
				addToast(
					'Ошибка',
					'Не удалось начать интервью. Попробуйте ещё раз.',
					'error',
				);
				setLoading(false);
			}
		} catch {
			addToast(
				'Ошибка',
				'Не удалось начать интервью. Попробуйте ещё раз.',
				'error',
			);
			setLoading(false);
		}
	};

	return (
		<div className="ai-msg-enter flex h-full w-full items-center justify-center bg-gray-5 px-6">
			<div className="w-full max-w-[560px]">
				<h1 className="mb-4 text-2xl font-semibold text-black">
					{problem.title}
				</h1>
				<div className="whitespace-pre-wrap text-base leading-[1.6] text-black">
					{message}
				</div>
				<div className="mt-6">
					<Button onClick={handleStart} loading={loading} size="lg">
						Начать <ChevronRight size={18} strokeWidth={2.5} />
					</Button>
				</div>
			</div>
		</div>
	);
}
